import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { SpacingVertical, SPACING_24 } from 'mailup-web-components'
import ErrorFeedback from 'Components/ErrorFeedback'

const InlineMessageBox = ({ inlineMessage, inlineMessageSeverity }) => {
  return (
    <>
      <ErrorFeedback
        error={inlineMessage}
        severity={inlineMessageSeverity}
        data-mu-test={classnames(
          'message-box',
          `message-box__${inlineMessageSeverity}`
        )}
      />
      <SpacingVertical variant={SPACING_24} />
    </>
  )
}

export default InlineMessageBox

InlineMessageBox.propTypes = {
  inlineMessage: PropTypes.any,
  inlineMessageSeverity: PropTypes.any
}
